import {
  ADVISOR_PROFILE_STATUS_APPLIED,
  ADVISOR_PROFILE_STATUS_APPROVED,
  ADVISOR_PROFILE_STATUS_REJECTED,
  ADVISOR_PROFILE_STATUS_SUSPENDED,
} from '@src/constants/advisor-profile-statuses'

/** Post-submit statuses that unlock the My Advisor Profile hub. Draft stays on apply. */
export const ADVISOR_PROFILE_HUB_STATUS_KEYS = [
  ADVISOR_PROFILE_STATUS_APPLIED,
  ADVISOR_PROFILE_STATUS_APPROVED,
  ADVISOR_PROFILE_STATUS_REJECTED,
  ADVISOR_PROFILE_STATUS_SUSPENDED,
] as const

export type AdvisorProfileHubStatusKey = (typeof ADVISOR_PROFILE_HUB_STATUS_KEYS)[number]

/**
 * Static children of `/advisors/profile`. Pages-router files win over `[memberSlug]`.
 * Keep this list in sync with `pages/advisors/profile/*.tsx`.
 */
export const ADVISOR_PROFILE_HUB_SEGMENTS = ['setup', 'view', 'edit', 'settings', 'payouts'] as const

export type AdvisorProfileHubSegment = (typeof ADVISOR_PROFILE_HUB_SEGMENTS)[number]

const normalizePath = (path: string) => path.split('?')[0].split('#')[0]

export const isAdvisorProfileHubEligible = (statusKey?: string | null): boolean =>
  ADVISOR_PROFILE_HUB_STATUS_KEYS.includes(statusKey as AdvisorProfileHubStatusKey)

export const isAdvisorProfileHubSegment = (segment: string): boolean =>
  ADVISOR_PROFILE_HUB_SEGMENTS.includes(segment as AdvisorProfileHubSegment)

/** Own hub: `/profile` or `/profile/{setup|view|edit|settings|payouts}`. */
export const isAdvisorProfileHubPath = (asPath: string, ownProfileHref: string): boolean => {
  const path = normalizePath(asPath)
  if (path === ownProfileHref) {
    return true
  }
  if (!path.startsWith(`${ownProfileHref}/`)) {
    return false
  }
  const segment = path.slice(ownProfileHref.length + 1).split('/')[0]
  return isAdvisorProfileHubSegment(segment)
}

/** Public directory card: `/profile/{memberSlug}` excluding reserved hub children. */
export const isPublicAdvisorProfilePath = (asPath: string, profileBase: string): boolean => {
  const path = normalizePath(asPath)
  if (!path.startsWith(`${profileBase}/`)) {
    return false
  }
  const segment = path.slice(profileBase.length + 1).split('/')[0]
  return !!segment && !isAdvisorProfileHubSegment(segment)
}
